export const DEFAULT_DELAY_TIMEOUT = 10000;
export const MAX_DELAY_TIMEOUT = 30000;
